import React, { useCallback, useState } from 'react';
import {
  Box,
  LockIcon,
  LogOutIcon,
  PopupWrapper,
  // DropContent,
  // Menu,
  Text,
} from '@common-fe/common-fe';
import styled from 'styled-components';

import { LetterIconSizeEnum } from '@/common/constants';
import { UserLetterIcon } from '@/components/elements/LetterIcon/UserLetterIcon';
import { useOrganizationOverridableProperties } from '@/modules/core/hooks/useOrganizationOverridableProperties';
import ChangePasswordModal from '@/modules/user/components/ChangePasswordModal/ChangePasswordModal';
import { useAuthorization } from '@/modules/user/hooks';
import { useAuthStore } from '@/modules/user/stores';
import currentTheme from '@/styles/theme';

import { useSmartSearchResentFinding } from './ToolbarSmartSearch/hooks';
import DropdownButton from './DropdownButton';

const StyledPopupContent = styled(Box)`
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: -5px;
    right: 21px;
    width: 10px;
    height: 10px;
    background-color: ${({ theme }) => theme.colors.canvas};
    transform: rotate(45deg);
    border-top-left-radius: ${({ theme }) => theme.spacings.spacing4};
  }
`;
const AnimatedPopupWrapper = styled(PopupWrapper)`
  @keyframes entrance {
    0% {
      opacity: 0;
      transform: translateY(-14px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
const POPUP_SHADOW = currentTheme.shadows.active['box-shadow'];

const UserDropdown = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isChangePasswordModalVisible, setIsChangePasswordModalVisible] = useState(false);
  const { user } = useAuthStore();
  const { handleLogout } = useAuthorization();
  const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
  const { clear } = useSmartSearchResentFinding();
  const { observingOrganizationData } = useOrganizationOverridableProperties();

  const handleOpenChangePasswordModal = useCallback(() => {
    setIsChangePasswordModalVisible(true);
  }, []);

  return (
    <>
      <Box>
        <AnimatedPopupWrapper
          flat
          flex
          testId="user-dropdown_popup"
          style={{
            top: '58px',
            boxShadow: POPUP_SHADOW,
            animation: 'entrance 0.3s ease-in-out',
            zIndex: 1000,
          }}
          onVisible={setIsVisible}
          content={(
            <StyledPopupContent direction="column" pad="spacing12" width="220px">
              <Box
                direction="row"
                pad={{ bottom: 'spacing8' }}
                border={{ color: 'border2', side: 'bottom', size: 'small' }}
              >
                <UserLetterIcon
                  size={LetterIconSizeEnum.LOGO}
                  text={fullName}
                  type={user?.organizationType}
                  sizePx="40"
                />
                <Box
                  direction="column"
                  justify="center"
                  margin={{
                    left: 'spacing12',
                  }}
                >
                  <Text size="medium" weight={700} color="textBody">
                    {fullName}
                  </Text>
                  {/* <Text size="small" weight={500} color="textDisabled">
                    Manage Account
                  </Text> */}
                </Box>
              </Box>

              {observingOrganizationData?.adminSsoOnly ? null : (
                <DropdownButton
                  testId="change-password"
                  icon={<LockIcon color="iconPrimary" />}
                  text="Change password"
                  onClick={handleOpenChangePasswordModal}
                />
              )}

              <DropdownButton
                data-testid="logout"
                icon={<LogOutIcon color="iconPrimary" />}
                text="Log Out"
                onClick={() => {
                  handleLogout();
                  clear();
                }}
              />
            </StyledPopupContent>
          )}
        >
          <UserLetterIcon
            size={LetterIconSizeEnum.LOGO}
            text={fullName}
            type={user?.organizationType}
            sizePx="40"
            isWithShadow={isVisible}
          />
        </AnimatedPopupWrapper>
      </Box>
      {isChangePasswordModalVisible && (
        <ChangePasswordModal
          onSetVisible={setIsChangePasswordModalVisible}
        />
      )}
    </>
  );
};

export default UserDropdown;
